import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { initializeFirebase } from './misc/firebase';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

initializeFirebase();

// Winter snowy effect
const currentMonth = new Date().getMonth();
if (currentMonth === 11 || currentMonth === 0) {
  const snowScript = document.createElement("script");
  snowScript.src = "https://app.embed.im/snow.js";
  snowScript.defer = true;
  document.body.appendChild(snowScript);
}
